import { createBrowserClient } from "@supabase/ssr";

// Browser-side Supabase client (anon key + the logged-in user's session).
// All client mutations go through this and are gated by Row Level Security.
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
